import { CallStatus } from '../../interface/call-status';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CallActions {
    export class SetCallStatus {
        static readonly type = '[Call] Set Status';
        constructor(public status: CallStatus | null) {}
    }

    export class StartCall {
        static readonly type = '[Call] Start Call';
    }

    export class EndCall {
        static readonly type = '[Call] End Call';
    }

    export class ToggleChat {
        static readonly type = '[Call] Toggle Chat';
    }

    export class ToggleSettings {
        static readonly type = '[Call] Toggle Settings';
    }
}
